<script>
  type errorResponse = { errors: Record<string, string[]> };

  export let errorMessage: string;

  function parseError(err: errorResponse | string): string {
    if (typeof err === "string") {
      return err;
    }

    const message = Object.entries(err.errors)
      .map(([_, value]) => value.join(", "))
      .join(", ");

    return message;
  }
</script>

<div class="form-errors">
  {@html parseError(errorMessage)}
</div>

<style lang="scss">
  .form-errors {
    margin-bottom: 10px;
    color: $warning-color;
  }
</style>
